import { formatURL } from "shelving";

export function LinkButton({ href, title, children = title || formatURL(href) }: { href: string; title?: string | undefined; children?: React.ReactNode }) {
	return (
		<a className="button" href={href}>
			{children}
		</a>
	);
}
